var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPyAlt1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_52)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.175 2.34479e-05C108.816 0.00941481 116.443 0.661716 123.975 1.95002C144.175 5.52502 147.825 12.975 147.825 26.75V45H100V51H165.75C179.6 51 191.75 59.325 195.55 75.175C200 93.35 200 104.7 195.55 123.675C192.15 137.8 184.05 147.875 170.2 147.875H153.775V126.075C153.602 118.24 150.402 110.776 144.846 105.249C139.291 99.721 131.811 96.5588 123.975 96.425H76.325C73.1678 96.3989 70.0468 95.7507 67.1403 94.5175C64.2338 93.2844 61.5989 91.4904 59.3862 89.2383C57.1735 86.9861 55.4264 84.3198 54.2448 81.392C53.0632 78.4642 52.4703 75.3322 52.5 72.175V26.75C52.5 13.825 63.4 4.10002 76.35 1.95002C84.5561 0.608824 92.8601 -0.043451 101.175 2.34479e-05ZM126.975 14.625C125.17 14.5953 123.397 15.103 121.882 16.0835C120.366 17.0641 119.176 18.4732 118.464 20.1317C117.751 21.7902 117.548 23.6231 117.88 25.3974C118.212 27.1717 119.064 28.8072 120.328 30.0959C121.592 31.3845 123.211 32.2682 124.979 32.6345C126.746 33.0008 128.583 32.8331 130.255 32.1528C131.927 31.4725 133.358 30.3104 134.368 28.8141C135.378 27.3178 135.92 25.5551 135.925 23.75C135.945 21.3541 135.014 19.048 133.336 17.3374C131.658 15.6268 129.371 14.6514 126.975 14.625Z",
    fill: "url(#paint0_linear_9_52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5249 51V72.175C46.5935 80.1062 49.739 87.701 55.2982 93.3581C60.8575 99.0153 68.3961 102.293 76.3249 102.5H123.975C130.329 102.63 136.38 105.24 140.836 109.771C145.292 114.301 147.8 120.395 147.825 126.75V172.125C147.825 185.05 136.6 192.65 123.975 196.35C108.463 201.211 91.8364 201.211 76.3249 196.35C64.2999 192.875 52.4999 185.875 52.4999 172.125V153.925H99.9999V147.875H28.5999C14.7499 147.875 9.57494 138.2 4.74994 123.675C-0.250061 108.675 -0.0250702 94.35 4.74994 75.175C8.17494 61.375 14.7499 51 28.5999 51H46.5249ZM73.3249 166C71.518 165.97 69.7431 166.479 68.2264 167.462C66.7098 168.445 65.5201 169.857 64.809 171.518C64.0979 173.18 63.8976 175.015 64.2337 176.791C64.5697 178.566 65.4268 180.202 66.6958 181.489C67.9648 182.775 69.5882 183.655 71.3591 184.016C73.1299 184.376 74.9681 184.202 76.6392 183.514C78.3103 182.826 79.7388 181.656 80.7425 180.153C81.7462 178.65 82.2797 176.882 82.2749 175.075C82.2816 172.692 81.3432 170.404 79.6654 168.712C77.9877 167.021 75.7076 166.063 73.3249 166.05V166Z",
    fill: "url(#paint1_linear_9_52)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_52",
    x1: 204.618,
    y1: 6.87902,
    x2: 94.3467,
    y2: 100.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9FD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_52",
    x1: 53.9779,
    y1: 159.596,
    x2: 93.693,
    y2: 104.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD43B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "matrix(-1 0 0 1 200 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyAlt1);
export default __webpack_public_path__ + "static/media/py-alt1.79752949d6cae386dcc5e61315310e98.svg";
export { ForwardRef as ReactComponent };